<script>
    export default {
      name: 'btn-check-possui',
      props: {
        value: {required: true}
      },
      data () {
        return {
          model: this.value
        }
      },
      computed: {},
      mounted () {
      },
      destroyed () {
      },
      methods: {
        __set (e) {
          this.$emit('input', this.model)
        }
      },
      components: {},
      watch: {
        value (v) {
          this.model = v
        }
      }
    }
</script>

<template>
  <div class="equipPussui">
    <span class="nao">Não possui</span>
    <label class="i-switch bg-success">
      <input @change="__set" v-model="model" type="checkbox">
      <i></i>
    </label>
    <span class="sim">Possui</span>
  </div>
</template>



// WEBPACK FOOTER //
// CheckPossui.vue?2245dd7e